module.exports = __webpack_public_path__ + "img/arrow-1.c9c79f12.svg";